module.exports = __webpack_public_path__ + "static/media/vertical_blank.bac271ab.png";